import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { StyledFormGroup, Feedback, MODES } from './Common';
import LocationFields from './LocationFields';
import InstitutionField from './InstitutionField';

const PGForm = ({
    register,
    sectionErrors,
    detailsPath,
    states,
    districts,
    institutions,
    setValue,
    onInstitutionAdded,
    selectedState,
    selectedDistrict,
    level
}) => {
    return (
        <>
            <LocationFields
                register={register}
                detailsPath={detailsPath}
                sectionErrors={sectionErrors}
                states={states}
                districts={districts}
                selectedState={selectedState}
            />

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Year <span className="text-danger">*</span></Form.Label>
                    <Form.Select {...register(`${detailsPath}.year`)} isInvalid={!!sectionErrors.year}>
                        <option value={1}>1st Year</option>
                        <option value={2}>2nd Year</option>
                    </Form.Select>
                    <Feedback error={sectionErrors.year} />
                </StyledFormGroup>

                <InstitutionField
                    label="Organization Name"
                    fieldName="collegeName"
                    register={register}
                    setValue={setValue}
                    sectionErrors={sectionErrors}
                    detailsPath={detailsPath}
                    institutions={institutions}
                    onInstitutionAdded={onInstitutionAdded}
                    selectedState={selectedState}
                    selectedDistrict={selectedDistrict}
                    level={level}
                />

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Place <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter place"
                        {...register(`${detailsPath}.place`)}
                        isInvalid={!!sectionErrors.place}
                    />
                    <Feedback error={sectionErrors.place} />
                </StyledFormGroup>
            </Row>

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Affiliated University</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Affiliated University"
                        {...register(`${detailsPath}.affiliatedUniversity`)}
                        isInvalid={!!sectionErrors.affiliatedUniversity}
                    />
                    <Feedback error={sectionErrors.affiliatedUniversity} />
                </StyledFormGroup>

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Program / Department</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter program/department"
                        {...register(`${detailsPath}.programDepartment`)}
                        isInvalid={!!sectionErrors.programDepartment}
                    />
                    <Feedback error={sectionErrors.programDepartment} />
                </StyledFormGroup>

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Mode <span className="text-danger">*</span></Form.Label>
                    <Form.Select {...register(`${detailsPath}.mode`)} isInvalid={!!sectionErrors.mode}>
                        {MODES.map(m => <option key={m} value={m}>{m}</option>)}
                    </Form.Select>
                    <Feedback error={sectionErrors.mode} />
                </StyledFormGroup>
            </Row>
        </>
    );
};

export default PGForm;
